import "./WorkbookCover.css";

// 원서 워크북 표지(2026-10-24 대표). 출제 때 옮겨 둔 문제집 첫 쪽 그림을 쓰고, 없으면(예전 과제) 글자로 그린다.
// 책 화면의 첫 쪽과 과제 첫 화면(BookEntrySelector)의 표지 자리에 같이 쓴다.
const LEVEL_TITLE = { beginner: "Beginner", intermediate: "Intermediate", advanced: "Advanced" };

const WorkbookCover = ({ book, title, compact = false }) => {
  const workbook = book || {};
  const coverTitle = title || workbook.book_title || "";
  const sourceList = (Array.isArray(workbook.parts) ? workbook.parts : [])
    .map((passage) => String((passage && passage.source) || "").trim())
    .filter(Boolean);
  const level = LEVEL_TITLE[workbook.level] || "";

  // 출제 때 옮겨 둔 문제집 첫 쪽(2026-10-24 대표: "문제집 첫 페이지 디자인을 표지로"). 없으면(예전 과제) 글자로 그린다.
  if (workbook.cover_url) {
    return (
      <div className={`workbook-cover workbook-cover--page${compact ? " workbook-cover--compact" : ""}`}>
        <img className="workbook-cover__page" src={workbook.cover_url} alt="" />
      </div>
    );
  }

  return (
    <div className={`workbook-cover${compact ? " workbook-cover--compact" : ""}`}>
      <div className="workbook-cover__spine" aria-hidden="true" />
      <div className="workbook-cover__top">
        <span className="workbook-cover__kicker">Reading Workbook</span>
        {level && <span className="workbook-cover__level">{level}</span>}
      </div>
      <h1 className="workbook-cover__title">{coverTitle}</h1>
      <div className="workbook-cover__rule" aria-hidden="true" />
      {sourceList.length > 0 && (
        <ol className="workbook-cover__sources">
          {sourceList.map((source, index) => (
            <li key={`${source}-${index}`}>
              <b>{String(index + 1).padStart(2, "0")}</b>
              <span>{source}</span>
            </li>
          ))}
        </ol>
      )}
      <div className="workbook-cover__mark" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M4 6c3-1.3 5.5-1.3 8 .5 2.5-1.8 5-1.8 8-.5v12c-3-1.3-5.5-1.3-8 .5-2.5-1.8-5-1.8-8-.5zM12 6.5v12.5" />
        </svg>
      </div>
    </div>
  );
};

export default WorkbookCover;
